<div class="card-container mat-elevation-z1">
  <div class="card-content">
    <form [formGroup]="form">
      <div *ngIf="!loading">
        <div class="full-width">
          <h4>Identificación</h4>
          <mat-divider></mat-divider>
          <div class="card-inline medium-width">
            <div class="card-inline full-width">
              <h5>
                Protocolo: <b>{{ protocol }}</b>
              </h5>
            </div>
            <div class="card-inline full-width">
              <h5>
                Fecha: <b>{{ appointmentDate | date : "dd/MM/yyyy" }}</b>
              </h5>
            </div>
            <div class="card-inline full-width">
              <h5>
                Paciente: <b>{{ patientFullName }}</b>
              </h5>
            </div>
            <div class="card-inline full-width">
              <h5>
                Edad: <b>{{ patientAge }}</b>
              </h5>
            </div>
            <div *ngIf="diagnostic" class="card-inline full-width">
              <h5>
                Diagnóstico: <b>{{ diagnostic }}</b>
              </h5>
            </div>
          </div>
          <div class="card-inline medium-width">
            <table
              class="full-width"
              mat-table
              [dataSource]="dataSourcePrincipal"
            >
              <tr
                mat-header-row
                class="table-header"
                *matHeaderRowDef="displayColumnsPrincipal"
              ></tr>
              <tr
                class="table-cell"
                mat-row
                *matRowDef="
                  let row;
                  let i = index;
                  columns: displayColumnsPrincipal
                "
              ></tr>
              <ng-container matColumnDef="PracticeRegionName">
                <th mat-header-cell class="table-header" *matHeaderCellDef>
                  Práctica
                </th>
                <td mat-cell class="table-cell" *matCellDef="let element">
                  {{ element.PracticeRegionName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="Quantity">
                <th mat-header-cell class="table-header" *matHeaderCellDef>
                  Cantidad
                </th>
                <td mat-cell class="table-cell" *matCellDef="let element">
                  {{ element.Quantity }}
                </td>
              </ng-container>
              <ng-container matColumnDef="AccessionNumber">
                <th mat-header-cell class="table-header" *matHeaderCellDef>
                  AN
                </th>
                <td mat-cell class="table-cell" *matCellDef="let element">
                  {{ element.AccessionNumber }}
                </td>
              </ng-container>
              <ng-container matColumnDef="PacsViewer">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell class="table-cell" *matCellDef="let element">
                  <mat-icon
                    class="cursor-default"
                    (click)="viewImages(element.AccessionNumber)"
                    >photo_library</mat-icon
                  >
                </td>
              </ng-container>
            </table>
          </div>
        </div>

        <div class="card-inline margin-top-medium">
          <h3>Cuerpo</h3>
        </div>
        <div class="card-inline">
          <button
            matTooltip="Previsualizar"
            *ngIf="!isDisabled"
            (click)="refreshStudyReportPdf()"
            mat-icon-button
            mat-mini-fab
          >
            <mat-icon>search</mat-icon>
          </button>
          <button
            matTooltip="Firmas"
            *ngIf="!isDisabled"
            (click)="openStudyReportPhysicianSignatureDialog()"
            mat-icon-button
            mat-mini-fab
          >
            <mat-icon>create</mat-icon>
          </button>
          <button
            matTooltip="Agregar plantillas"
            *ngIf="!isDisabled"
            (click)="openStudyReportTemplateFiltersDialog()"
            mat-icon-button
            mat-mini-fab
          >
            <mat-icon>add</mat-icon>
          </button>

          <button
            matTooltip="Ver estudios previos"
            class="margin-right-medium full-width"
            *ngIf="!isDisabled"
            (click)="openPreviusStudiesShowDialog()"
            mat-icon-button
            mat-mini-fab
          >
            <mat-icon>photo_album</mat-icon>
          </button>

          <button
            matTooltip="Adjuntar PDF como informe"
            class="card-inline"
            (click)="fileInput.click()"
            mat-mini-fab
          >
            <mat-icon>cloud_upload</mat-icon>
            <input
              [style.display]="hideElement ? 'none' : 'inherit'"
              type="file"
              #fileInput
              (change)="uploadFile($event.target.files)"
            />
          </button>

          <button
            matTooltip="Importar Imágenes"
            *ngIf="!isDisabled && !importingImages"
            (click)="importKeyImages()"
            mat-icon-button
            mat-mini-fab
          >
            <mat-icon> import_export </mat-icon>
          </button>

          <button
            *ngIf="studyReportWizardService.studykeyImage.KeyImageIds.length > 0"
            matTooltip="Visualizar Imágenes"
            (click)="viewKeyImages()"
            mat-icon-button
            mat-mini-fab
          >
            <mat-icon>photo_library</mat-icon>
          </button>

          <button
            matTooltip="Apertura HCE"
            (click)="medicalRecordPublish()"
            mat-icon-button
            mat-mini-fab
          >
            <mat-icon>receipt</mat-icon>
          </button>

          <div class="card-inline" style="padding: 5px">
            <mat-spinner *ngIf="importingImages" diameter="20"></mat-spinner>
          </div>
        </div>

        <mat-divider></mat-divider>
        <div class="text-center" *ngIf="autoSaveDate">
          <h6>
            <b>auto guardado {{ autoSaveDate | date : "mediumTime" }}</b>
          </h6>
        </div>
        <div class="center" *ngIf="uploadingImage">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
        <div
          *ngIf="environmentPreset.txControl"
          style="text-align: center"
          class="margin-top-medium margin-botton-medium"
        >
          <!-- <tx-document-editor
            width="1024px"
            height="900px"
            [documentTargetMarkers]="true"
            [webSocketURL]="txControlSocketUrl"
          >
          </tx-document-editor> -->
        </div>
        <div *ngIf="environmentPreset.tinyEditor" class="margin-botton-medium">
          <textarea
            appPasteImage
            (imagesPasted)="onImagesPasted($event)"
            formControlName="StudyReportText"
            id="tiny"
          ></textarea>
        </div>
        <div
          *ngIf="!environmentPreset.tinyEditor && !environmentPreset.txControl"
          class="margin-botton-medium"
        >
          <angular-editor
            id="editor1"
            (focus)="focus('editor1')"
            formControlName="StudyReportText"
            [config]="editorConfig"
          ></angular-editor>
        </div>
        <div *ngIf="visualizeConclusion" class="card-inline">
          <h3>Conclusión</h3>
        </div>
        <mat-divider *ngIf="visualizeConclusion"></mat-divider>
        <div *ngIf="visualizeConclusion" class="margin-top-medium">
          <angular-editor
            id="editor2"
            (focus)="focus('editor2')"
            formControlName="StudyReportConclusion"
            [config]="editorConfig"
          ></angular-editor>
        </div>
      </div>
    </form>
  </div>
</div>
